import React from "react";

import { placeOfBirthValidationPattern } from "@gp/common";

import { FormInputField } from "@components-shared/desktop/inputs";

export default function RegistrationPOB(props: { labelClassName?: string }) {
	const { labelClassName } = props;

	return (
		<FormInputField
			id="birthPlace"
			className="form__field"
			name="birthPlace"
			minLength={3}
			maxLength={80}
			label="registration:BIRTH_PLACE_LABEL"
			labelClassName={labelClassName}
			placeholder="registration:BIRTH_PLACE_PLACEHOLDER"
			pattern={{
				value: placeOfBirthValidationPattern,
				message: "registration:INVALID_BIRTH_PLACE",
			}}
			required
		/>
	);
}
